module.exports = __webpack_public_path__ + "img/check.3c4fbc70.svg";